import styled, { css, keyframes } from 'styled-components';

import { FileStatus, RowIDStatus } from 'const';

import { pxToRem } from 'utils/scss';

export const TableContainer = styled.div`
  margin: auto;
`;

export const Seperator = styled.div`
  ${props =>
    props.header
      ? css`
          opacity: 0.16;
          height: ${pxToRem('1px')};
          width: 94%;
          margin: ${pxToRem('0px')} ${pxToRem('10px')};
          border: ${pxToRem('0.5px')} solid
            ${({ theme }) => theme.colors.lightBlack};
        `
      : css`
          opacity: 0.16;
          height: ${pxToRem('1px')};
          width: 94%;
          border: ${pxToRem('0.5px')} solid
            ${({ theme }) => theme.colors.lightBlack};
        `}
`;

export const ErrorDetailRow = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 2fr;
  grid-column: 2fr 3fr;
  padding: ${pxToRem('10px')};
  text-align: center;
`;

export const ErrorDetailsContainer = styled.div`
  padding: ${pxToRem('24px')} ${pxToRem('30px')} ${pxToRem('24px')}
    ${pxToRem('16px')};
  border-radius: ${pxToRem('8px')};
  border: solid ${pxToRem('1px')} rgba(7, 11, 21, 0.16);
  background-color: rgba(255, 255, 255, 0.03);
  margin: ${pxToRem('10px')};
  font-family: ${({ theme }) => theme.fontset.opensans};
`;

const spin = keyframes`
    0% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
`;

export const StatusInProgressIcon = styled.div`
  width: ${pxToRem('22px')};
  height: ${pxToRem('22px')};
  font-size: ${pxToRem('10px')};
  margin: 0 auto;
  border-radius: 50%;
  border: ${pxToRem('2px')} solid #00d7a3;
  border-left: 0.8em solid white;
  animation: ${spin} 1.1s infinite linear;
`;

export const HistoryTableContainer = styled.div`
  margin: ${pxToRem('20px')} ${pxToRem('15px')};
`;

export const ExpandedRowContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ExpandedRowDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.justify};
  padding: 0 ${pxToRem(15)};
`;

export const ExpandedRowText = styled.div`
  color: ${props => {
    switch (props.fileStatus) {
      case 'WARNING':
        return props.theme.colors.semantic.primary;
      case 'SUCCESS':
        return props.theme.colors.statusGreen;
      default:
        return props.theme.colors.semantic.secondary;
    }
  }};
  font-size: ${pxToRem('12px')};
  margin-bottom: ${pxToRem('10px')};
  font-family: ${({ theme }) => theme.fontset.opensans};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;

  :hover {
    cursor: pointer;
  }
`;

export const UpArrow = styled.div`
  width: ${pxToRem('10px')};
  height: ${pxToRem('10px')};
  border: solid
    ${props =>
      props.type === 'fileHistory'
        ? props.fileStatus === 'WARNING'
          ? props.theme.colors.semantic.primary
          : props.theme.colors.semantic.secondary
        : '#467afb'};
  border-width: 0 ${pxToRem('3px')} ${pxToRem('3px')} 0;
  display: inline-block;
  padding: ${pxToRem('3px')};
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  margin-left: ${pxToRem('8px')};
`;

export const DownArrow = styled.div`
  width: ${pxToRem('10px')};
  height: ${pxToRem('10px')};
  border: solid
    ${props =>
      props.type === 'fileHistory'
        ? props.fileStatus === 'WARNING'
          ? props.theme.colors.semantic.primary
          : props.theme.colors.semantic.secondary
        : '#467afb'};
  border-width: 0 ${pxToRem('3px')} ${pxToRem('3px')} 0;
  display: inline-block;
  padding: ${pxToRem('3px')};
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  margin-left: ${pxToRem('8px')};
`;

export const RowDetailTable = styled.div`
  padding: ${pxToRem('20px')};
  border-radius: ${pxToRem('8px')};
  border: solid ${pxToRem('1px')} rgba(7, 11, 21, 0.16);
  background-color: rgba(255, 255, 255, 0.03);
  margin: ${pxToRem('20px')} ${pxToRem('30px')};
`;

export const RowData = styled.div`
  display: grid;
  grid-template-columns: 1fr 2.5fr;
  grid-column: 2fr 3fr;
  padding: ${pxToRem('10px')};
  text-align: center;
  color: ${props =>
    props.status === FileStatus.WARNING
      ? props.theme.colors.semantic.primary
      : props.status === RowIDStatus.FAILURE
      ? props.theme.colors.semantic.secondary
      : props.theme.colors.black.six};
`;

export const RowIndex = styled.div`
  font-family: OpenSans;
  font-size: ${pxToRem('16px')};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
`;

export const RowMessage = styled(RowIndex)`
  text-align: right;
`;
